import { render, staticRenderFns } from "./VideoNodeComponent.vue?vue&type=template&id=08fd3c3e"
import script from "./VideoNodeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoNodeComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports